import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import ComputerIcon from "@mui/icons-material/ComputerOutlined";
import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import PaletteIcon from "@mui/icons-material/PaletteOutlined";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";

import { useState } from "react";

type Mode = "system" | "light" | "dark";

const ColorSchemeMenu = () => {
  const { mode, setMode } = useColorScheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleSelectMode = (selectedMode: Mode) => {
    setMode(selectedMode);
    setAnchorEl(null);
  };

  return (
    <>
      <MenuItem
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <ListItemIcon>
          <PaletteIcon />
        </ListItemIcon>
        <ListItemText>Color Scheme</ListItemText>
        <ChevronRightIcon color="action" sx={{ ml: 1 }} />
      </MenuItem>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "center", horizontal: "right" }}
        transformOrigin={{ vertical: "center", horizontal: "left" }}
        slotProps={{ paper: { sx: { ml: 1, minWidth: "13rem" } } }}
      >
        <MenuItem selected={mode === "light"} onClick={() => handleSelectMode("light")}>
          <ListItemIcon>
            <LightModeIcon />
          </ListItemIcon>
          <ListItemText>Light</ListItemText>
        </MenuItem>
        <MenuItem selected={mode === "dark"} onClick={() => handleSelectMode("dark")}>
          <ListItemIcon>
            <DarkModeIcon />
          </ListItemIcon>
          <ListItemText>Dark</ListItemText>
        </MenuItem>
        <MenuItem selected={mode === "system"} onClick={() => handleSelectMode("system")}>
          <ListItemIcon>
            <ComputerIcon />
          </ListItemIcon>
          <ListItemText>System</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ColorSchemeMenu;
